// Task/3424 (Refund Authenticator) - mirrors ToothTeller-Controller-API's
// Features/RefundSettlementTemplate, RefundReasonCode, RefundApprovalRule,
// RefundSignatureSettings DTOs and Commands (same repo/task).

export class CreateRefundSettlementTemplateCommand {
  practiceId: number = 0;
  name: string = '';
  bodyText: string = '';
  // Concept screen 6's required attestation checkbox - "An authorized representative of our
  // organization has reviewed and approved this language."
  reviewedAttestation: boolean = false;
}

export class RefundSettlementTemplateDetails {
  id: number;
  practiceId: number;
  name: string;
  version: number;
  bodyText: string;
  status: boolean;
  reviewedBy: number | null;
  reviewedByName: string | null;
  reviewedOn: string | null;
  createdBy: number;
  createdOn: string;
}

export class RefundReasonCodeDetails {
  id: number;
  practiceId: number;
  code: string;
  label: string;
  isActive: boolean;
}

export class CreateRefundReasonCodeCommand {
  practiceId: number = 0;
  code: string = '';
  label: string = '';
}

export class UpdateRefundReasonCodeCommand {
  id: number = 0;
  label: string = '';
  isActive: boolean = true;
}

export class RefundApprovalRuleItem {
  minAmount: number = 0;
  maxAmount: number | null = null;
  approverRoleName: string = '';
}

export class SaveRefundApprovalRulesCommand {
  practiceId: number = 0;
  rules: RefundApprovalRuleItem[] = [];
}

export class RefundApprovalRuleDetails extends RefundApprovalRuleItem {
  id: number;
  practiceId: number;
  sortOrder: number;
}

export enum RefundIdentityCheckMethod {
  DateOfBirth = 1,
  OneTimeCode = 2,
}

export class SaveRefundSignatureSettingsCommand {
  practiceId: number = 0;
  digitalSignatureEnabled: boolean = true;
  manualUploadEnabled: boolean = true;
  identityCheckMethod: RefundIdentityCheckMethod = RefundIdentityCheckMethod.DateOfBirth;
  expirationDays: number = 10;
  reminderDaysCsv: string | null = '3,7';
  brandingAccentColor: string | null = null;
  brandingLogoUrl: string | null = null;
  brandingReplyToEmail: string | null = null;
  // Task 3537: a full refund above this amount is sent for approval (default 200, 0 = every full refund).
  fullRefundApprovalLimit: number = 200;
}

export class RefundSignatureSettingsDetails extends SaveRefundSignatureSettingsCommand {}
